import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: '',
    username: '',
    usertype:''
  },
  getters: {
    getToken: function (state) {
      if (!state.token) {
        if (sessionStorage.token) {
          state.token = sessionStorage.token;
        }
      }
      return state.token;
    },
    getUsername: function (state) {
      if (!state.username) {
        if (sessionStorage.username) {
          state.username = sessionStorage.username;
        }
      }
      return state.username;
    },
    getUsertype: function (state) {
      if (!state.usertype) {
        if (sessionStorage.usertype) {
          state.usertype = sessionStorage.usertype;
        }
      }
      return state.usertype;
    }
  },
  mutations: {
    setTokens (state, token) {
      state.token = token;
      sessionStorage.token = token;
    },
    delTokens (state) {
      state.token = '';
      sessionStorage.removeItem('token');
    },
    refreshToken (state) {
      state.token = sessionStorage.token;
    },
    setUsername (state, username) {
      state.username = username;
      sessionStorage.username = username;
    },
    setUsertype (state, usertype) {
      state.usertype = usertype;
      sessionStorage.usertype = usertype;
    }
  },
  actions: {
    setToken ({commit}, token) {
      commit('setTokens', token);
    },
    delToken ({commit}) {
      commit('delTokens');
    },
    refresh ({commit}) {
      commit('refreshToken');
    },
    setUsername ({commit}, username) {
      commit('setUsername', username);
    },
    setUsertype ({commit}, usertype) {
      commit('setUsertype', usertype);
    }
  }
});
